// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tips[data-v-1dec0c48]{display:inline-block;margin-right:20px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
